import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import useIdleTimer from '../hooks/useIdleTimer';
import { saveData, removeAllAnswers } from '../utils';
import { prizeEn } from '../assets/data/prizeEN';
import { prizeFr } from '../assets/data/prizeFR';

import pattern from '../assets/images/pattern.png';

import WheelWrapper from '../components/WheelWrapper';

const Game = () => {
  const { i18n } = useTranslation();

  const [prizeData, setPrizeData] = useState(i18n.language === 'en' ? prizeEn : prizeFr);
  const [prizeNumber, setPrizeNumber] = useState(null);
  const [isSpinning, setSpinning] = useState(false);

  const userAnswers = localStorage.getItem('user-answers');

  const startTime = useSelector(({ time }) => time.startTime);

  const navigate = useNavigate();

  useEffect(() => {
    if (!userAnswers) {
      navigate('/');

      return;
    }

    if (prizeNumber === 1 || prizeNumber === 2 || prizeNumber === 3) {
      saveData(startTime, prizeData[prizeNumber]?.option, 'complete');

      localStorage.removeItem('user-info');
      localStorage.removeItem('user-answers');
      removeAllAnswers();
    }

    if (prizeNumber === 0) {
      saveData(startTime, null, 'complete');

      localStorage.removeItem('user-info');
      localStorage.removeItem('user-answers');
      removeAllAnswers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prizeData, prizeNumber]);

  useIdleTimer();

  return (
    <>
      <img src={pattern} alt="pattern" className="lg:w-full w-[60%] absolute left-0 bottom-0" />

      <WheelWrapper
        prizeData={prizeData}
        setPrizeData={setPrizeData}
        prizeNumber={prizeNumber}
        setPrizeNumber={setPrizeNumber}
        isSpinning={isSpinning}
        setSpinning={setSpinning}
      />
    </>
  );
};

export default Game;
